import CreateDriverInvoicePage from './CreateDriverInvoicePage'

const CreateSubHaulerInvoicePage: React.FC = () => {
  return <CreateDriverInvoicePage invoiceType="SUB_HAULER" />
}

export default CreateSubHaulerInvoicePage
